import { rdlIsNumber } from '@roller/rdl/utilities/number';
import { rdlConvertTimeIndexToString, rdlFormatDate } from '@roller/rdl/utilities/date';

/**
 * Formats a session time from a 4-digit number  to a venue defined display format.
 *
 * @param {number | string | Date} sessionTime - The session time in 24-hour format (e.g., 1700) as a number or string, or date set with time
 * @param {TVenueTimeFormat} timeFormat - The format to use for the time set in the venue settings.
 * @param {string} locale - The locale to use when formatting the date via Angular
 * @returns {string} The formatted session time according to the configured time format.
 */
function rdlFormatSessionTime(sessionTime, timeFormat, locale) {
  try {
    sessionTime = rdlConvertTimeIndexToString(sessionTime);
    const removeTrailingZeros = timeFormat.indexOf('CUSTOM_') === 0;
    const isUpper = timeFormat === 'CUSTOM_UPPER' || timeFormat === 'h:mm A';
    const time = new Date();
    const hours = parseInt(sessionTime.substring(0, 2));
    const minutes = parseInt(sessionTime.substring(2, 4));
    time.setHours(hours, minutes, 0, 0);
    const format = timeFormat === 'HH:mm' ? 'HH:mm' : 'h:mm a';
    let result = rdlFormatDate(time, format, locale);
    result = isUpper ? result.toUpperCase() : result.toLowerCase();
    return removeTrailingZeros ? result.replace(':00', '') : result;
  } catch {
    return 'Unknown';
  }
}
/**
 * Calculates the end time of a session based on its start time and duration.
 *
 * @param sessionStart - The start time of the session in HHMM format (e.g., 1300 for 1:00 PM).
 * @param sessionDuration - The duration of the session in minutes.
 * @returns number - The end time of the session in HHMM format, or `undefined` if the input is invalid.
 * @example rdlGetSessionEndTime(1300, 60) => 1400
 */
function rdlGetSessionEndTime(sessionStart, sessionDuration) {
  if (sessionDuration === 0) {
    return sessionStart;
  }
  if (!rdlIsNumber(sessionDuration) || !rdlIsNumber(sessionStart)) {
    return undefined;
  }
  const durationHours = Math.floor(sessionDuration / 60);
  const durationMinutes = sessionDuration % 60;
  const sessionHours = Math.floor(sessionStart / 100);
  const sessionMinutes = (sessionStart - sessionHours * 100) % 60;
  const totalHours = sessionHours + durationHours + Math.floor((sessionMinutes + durationMinutes) / 60);
  const totalMinutes = (sessionMinutes + durationMinutes) % 60;
  return (totalHours * 100 + totalMinutes) % 2400;
}

/**
 * Generated bundle index. Do not edit.
 */

export { rdlFormatSessionTime, rdlGetSessionEndTime };
